/**
 * @file CartModeScheme.tsx
 * @description Схемы вида корзины для `OptionCards` (phase19.16, SB120 этап 4;
 * uiux-cart §5, SB122 «схемы вместо слов»): полоса шапки сверху и корзина —
 * окном под шапкой справа или панелью во всю высоту у выбранной стороны.
 */

import type { SiteCartMode, SiteCartSide } from "@chaiberi/shared";

import { cn } from "@/lib/utils";

export function CartModeScheme({ mode, side }: { mode: SiteCartMode; side: SiteCartSide }) {
  return (
    <span aria-hidden className="relative block h-10 w-16 overflow-hidden rounded-sm bg-outline-variant/40">
      <span className="absolute inset-x-0 top-0 h-2 bg-on-surface-variant/40" />
      {mode === "drawer" ? (
        <span className={cn("absolute inset-y-0 w-5 bg-on-surface-variant/70", side === "left" ? "left-0" : "right-0")} />
      ) : (
        <span className="absolute right-1 top-3 h-5 w-7 rounded-[2px] bg-on-surface-variant/70" />
      )}
    </span>
  );
}
